import React from "react";
import { useTranslation } from "react-i18next";
import { Globe, ChevronDown } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../ui/dropdown-menu";

const LANGS = [
    { code: "tr", label: "TR", name: "Türkçe" },
    { code: "en", label: "EN", name: "English" },
    { code: "de", label: "DE", name: "Deutsch" },
];

export default function LangSwitcher() {
    const { i18n } = useTranslation();
    const current = LANGS.find((l) => l.code === (i18n.language || "tr").split("-")[0]) || LANGS[0];

    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                className="inline-flex items-center gap-1 text-sm px-2 py-1.5 rounded-md text-dark-navy hover:bg-light-bg outline-none"
                data-testid="lang-switcher-trigger"
            >
                <Globe className="w-4 h-4" />
                <span className="font-semibold">{current.label}</span>
                <ChevronDown className="w-3.5 h-3.5" />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="min-w-[140px]">
                {LANGS.map((l) => (
                    <DropdownMenuItem
                        key={l.code}
                        onClick={() => {
                            i18n.changeLanguage(l.code);
                        }}
                        data-testid={`lang-option-${l.code}`}
                        className="flex items-center justify-between"
                    >
                        <span>{l.name}</span>
                        <span className="text-xs text-slate-500">{l.label}</span>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
